import store from '@/store'

import {RawWikiNode} from '@/types/entity/RawWiki'

import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import TreeSelectField from '@/components/Ui/ActiveForm/BZCore/Fields/TreeSelectField'

// @ts-ignore
import messages from '@/lang/index';

const createForm: ActiveFormOptions = {
  label: messages.wiki.node,
  submitText: messages.wiki.edit_node_name,
  async onSubmit (data: RawWikiNode) {
    console.log('LOG: onSubmit -> data', data)
    let nodeData = {
      id: data.id,
      title: data.title
    }
    await store.dispatch('wiki/updateNode', nodeData)
    await store.dispatch('wiki/nodeParent', {id: data.id, parent: data.parent})
  },
  inputs: {
    title: {
      label: messages.labels.title,
      type: StringField,
      required: true,
      options: {}
    },
    parent: {
      label: messages.wiki.node,
      type: TreeSelectField,
      options: {
        async values (scope: any) {
          let list = await store.dispatch('wiki/getNodesTree')
          let tree = [
            {
              title: messages.labels.main_node,
              id: '',
              children: list
            }
          ]
          return tree;
        },
        treeProps: {
          label: 'title'
        },
        nodeKey: 'id'
      }
    }
  },
  steps: [
    {
      map: [
        ['title', 'parent']
      ]
    }
  ]
}

export default createForm